import {BaseModel} from "@/model/BaseModel";

/**
 * @property {string} Density
 * @property {string} Excise
 * @property {string} Name
 * @property {string} Type
 * @property {string} Supplier
 * @property {string} QualityPassport
 */
export class Product extends BaseModel {

    static fields = [
        {setDensity: parseFloat},
        {setExcise: parseFloat},
        'setName',
        'setType',
        'setSupplier',
        'setQualityPassport'
    ]

    constructor(product = {}) {
        super(product, Product.fields)
    }

}